import { datasource } from "./datasource";
import i18n from "i18next";
import * as moment from "moment";
export const specSheetDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("spec_sheet", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        customer_id: {
          type: "string",
        },
        customer: {
          type: "string",
        },
        name: {
          type: "string",
          alter: true,
        },
        hand: {
          type: "string",
        },
        ball_grip: {
          type: "string",
        },
        f1_rev: {
          type: "string",
        },
        f1_lat: {
          type: "string",
        },
        f1_for: {
          type: "string",
        },
        f1_grip_type: {
          type: "string",
        },
        f1_od: {
          type: "string",
        },
        f1_vacu: {
          type: "string",
          alter: true,
        },
        f1_oval: {
          type: "string",
          alter: true,
        },
        f1_size: {
          type: "string",
        },
        f1_span_full: {
          type: "string",
        },
        f1_span_cut: {
          type: "string",
        },
        f1_span_outer2_cut: {
          type: "string",
        },
        f1_span_hole_to_hole: {
          type: "string",
        },
        f1_span_insert2_cut: {
          type: "string",
        },
        bridge: {
          type: "string",
        },
        vacu: {
          type: "string",
          alter: true,
        },
        clt: {
          type: "string",
          alter: true,
        },
        f2_rev: {
          type: "string",
        },
        f2_lat: {
          type: "string",
        },
        f2_for: {
          type: "string",
        },
        f2_grip_type: {
          type: "string",
        },
        f2_od: {
          type: "string",
        },
        f2_vacu: {
          type: "string",
          alter: true,
        },
        f2_oval: {
          type: "string",
          alter: true,
        },
        f2_size: {
          type: "string",
        },
        f2_span_full: {
          type: "string",
        },
        f2_span_cut: {
          type: "string",
        },
        f2_span_outer2_cut: {
          type: "string",
        },
        f2_span_hole_to_hole: {
          type: "string",
        },
        f2_span_insert2_cut: {
          type: "string",
        },
        thm_type: {
          type: "string",
        },
        thm_rev: {
          type: "string",
        },
        thm_lat_l: {
          type: "string",
        },
        thm_lat_r: {
          type: "string",
        },
        thm_for: {
          type: "string",
        },
        thm_od: {
          type: "string",
        },
        thm_size: {
          type: "string",
        },
        thm_oval_starting_bit: {
          type: "string",
        },
        thm_oval_width: {
          type: "string",
        },
        thm_oval_degree: {
          type: "string",
        },
        thm_oval_taper: {
          type: "string",
          alter: true,
        },
        thm_round_taper: {
          type: "string",
          alter: true,
        },
        thm_insert_type: {
          type: "string",
        },
        thm_flex: {
          type: "string",
        },
        thm_offset: {
          type: "string",
        },
        note: {
          type: "string",
        },
        have_images: {
          type: "boolean",
          default: false,
          alter: true,
        },
        gallery: {
          type: "raw",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
        // Free-form JSON already carried by every SyncAudit table. Kept in
        // the model so it survives a round trip: the API writes whatever the
        // client sends, so a record saved without it would have it wiped.
        extra_values: {
          type: "raw",
          alter: true,
        },
      },
      name_value: function () {
        return this.get("name") || "";
      },
      hand_value: function () {
        return i18n.t(this.get("hand"));
      },
      ball_grip_value: function () {
        return i18n.t(this.get("ball_grip"));
      },
      f1_span_full_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_span_full")
          : this.get("f1_span_full");
      },
      f2_span_full_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_span_full")
          : this.get("f2_span_full");
      },
      f1_span_cut_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_span_cut")
          : this.get("f1_span_cut");
      },
      f2_span_cut_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_span_cut")
          : this.get("f2_span_cut");
      },
      f1_span_outer2_cut_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_span_outer2_cut")
          : this.get("f1_span_outer2_cut");
      },
      f2_span_outer2_cut_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_span_outer2_cut")
          : this.get("f2_span_outer2_cut");
      },
      f1_span_hole_to_hole_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_span_hole_to_hole")
          : this.get("f1_span_hole_to_hole");
      },
      f2_span_hole_to_hole_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_span_hole_to_hole")
          : this.get("f2_span_hole_to_hole");
      },
      f1_lat_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_lat")
          : this.get("f1_lat");
      },
      f2_lat_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_lat")
          : this.get("f2_lat");
      },
      f1_for_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_for")
          : this.get("f1_for");
      },
      f2_for_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_for")
          : this.get("f2_for");
      },
      f1_rev_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_rev")
          : this.get("f1_rev");
      },
      f2_rev_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_rev")
          : this.get("f2_rev");
      },
      f1_grip_type_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_grip_type")
          : this.get("f1_grip_type");
      },
      f2_grip_type_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_grip_type")
          : this.get("f2_grip_type");
      },
      f1_size_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_size")
          : this.get("f1_size");
      },
      f2_size_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_size")
          : this.get("f2_size");
      },
      f1_oval_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_oval")
          : this.get("f1_oval");
      },
      f2_oval_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_oval")
          : this.get("f2_oval");
      },
      f1_od_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_od")
          : this.get("f1_od");
      },
      f2_od_value: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_od")
          : this.get("f2_od");
      },
      dateCreatedValue: function () {
        return moment(this.get("created_at") * 1).format(
          "YYYY MMMM D HH:mm:ss"
        );
      },
      dateUpdatedValue: function () {
        return moment(this.get("updated_at") * 1).format(
          "YYYY MMMM D HH:mm:ss"
        );
      },
      isF1OdVisible: function () {
        return this.get("f1_grip_type") && this.get("f1_grip_type") !== "";
      },
      isF2OdVisible: function () {
        return this.get("f2_grip_type") && this.get("f2_grip_type") !== "";
      },
      isF1OdBindVisible: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f2_grip_type") && this.get("f2_grip_type") !== ""
          : this.get("f1_grip_type") && this.get("f1_grip_type") !== "";
      },
      isF2OdBindVisible: function () {
        return this.get("hand") === "left_hander"
          ? this.get("f1_grip_type") && this.get("f1_grip_type") !== ""
          : this.get("f2_grip_type") && this.get("f2_grip_type") !== "";
      },
      isOvalThumb: function () {
        return this.get("thm_type") === "Oval";
      },
      spanFullFilled: function () {
        return this.get("f1_span_full") && this.get("f2_span_full");
      },
      spanCutFilled: function () {
        return this.get("f1_span_cut") && this.get("f2_span_cut");
      },
      spanOuter2CutFilled: function () {
        return this.get("f1_span_outer2_cut") && this.get("f2_span_outer2_cut");
      },
      spanhole_to_holeFilled: function () {
        return (
          this.get("f1_span_hole_to_hole") && this.get("f2_span_hole_to_hole")
        );
      },
      isOvalCalculationVisible: function () {
        return this.get("thm_type") === "Oval";
      },
    },
    parse: function (response) {
      var values = response,
        n = values.length,
        i = 0,
        value;
      for (; i < n; i++) {
        value = values[i];
        value.spec_sheet_date =
          (value.name || "") +
          " " +
          moment(value.updated_at * 1).format("YYYY MMMM D");
      }

      return response;
    },
  });
